import { COUNTRY_SUMMARY_ITEM } from '../../../../components/SummaryList/SummaryItems/base';
import { NAME_PRE_SALT_POLYGON_SUMMARY_ITEM } from '../../../../components/SummaryList/SummaryItems/presaltPolygoon';

export default [NAME_PRE_SALT_POLYGON_SUMMARY_ITEM, COUNTRY_SUMMARY_ITEM];
